import axios from "axios";
import { appPdfServiceUrl, appPdfServiceKey } from "../common/constants";
import { appLog } from "../common/utils/app-log";

const pdfFile = async (token: string, pdfData: any) => {
    // 1 - config axios
    const httpPdfService = axios.create({
        baseURL: appPdfServiceUrl,
        headers: {
            'Content-Type': 'application/javascript',
            'Ocp-Apim-Subscription-Key': appPdfServiceKey,
            'Authorization': `Bearer ${token}`,
        },
    });
    let pdfPah = "";
    try {
        const response = await httpPdfService.post<any>(`/pdf-file`, pdfData, { headers: { "Content-Type": "application/json" }, responseType: "blob" });
        if (response.data != null) {
            const pdfBlob = new Blob([response.data as unknown as BlobPart], { type: "application/pdf" });
            pdfPah = window.URL.createObjectURL(pdfBlob);
        }
    }
    catch (e: any) {
        appLog.error(e);
    }
    return pdfPah;
}

export const pdfService = {
    pdfFile,
};
